import React, { useRef } from "react";
import HomeBanner from "./home/HomeBanner";
import LatestProperties from "./home/LatestProperties";
import ChooseProperties from "./home/ChooseProperties";
import BestCities from "./home/BestCities";
import OurAgents from "./home/OurAgents";
import Achivement from "./home/Achivement";
import OurClientSays from "./home/OurClientSays";
import Newslatter from "./home/Newslatter";
import BHKchoiceInMind from "./home/BHKchoiceInMind";
import InsightsandTools from "./home/InsightsandTools";
import PopularBuilders from "./home/PopularBuilders";
import RecommendedProperties from "./home/RecommendedProperties";
import ApartmentsVillas from "./home/ApartmentsVillas";
import MoveInNow from "./home/MoveInNow";
import CheckPropertyRates from "./home/CheckPropertyRates";
import ExploreOurServices from "./home/ExploreOurServices";
import ExploreRealEstate from "./home/ExploreRealEstate";
import CuratedPgCollections from "./home/CuratedPgCollections";
import HomesByFurnishing from "./home/HomesByFurnishing";
import RecentelySearched from "./PropertyInfo/RecentelySearched";
import PostProperty from "./PropertyInfo/PostProperty";
import { Link } from "react-router-dom";
import SubcriptionPage from "./SubcriptionPage";
import BoostedProperty from "./home/BoostedProperty";
import { FiShare2 } from "react-icons/fi";

const Home = () => {
  const isSharingRef = useRef(false);

  const handleShare = async (e) => {
    if (e) {
      if (typeof e.preventDefault === "function") e.preventDefault();
      if (typeof e.stopPropagation === "function") e.stopPropagation();
    }

    // Debounce to prevent multiple rapid triggers
    if (isSharingRef.current) return;
    isSharingRef.current = true;

    const shareUrl = window.location.href;
    const shareTitle = "EwRealty";
    const shareText = "Find top verified properties, flats, and villas on EwRealty: ";

    try {
      if (navigator.share) {
        try {
          await navigator.share({
            title: shareTitle,
            text: shareText,
            url: shareUrl,
          });
        } catch (error) {
          // If the user cancelled/closed the native share sheet, ignore (never reopen!)
          if (error.name !== "AbortError") {
            const fallbackUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
              `${shareTitle} - ${shareText} ${shareUrl}`
            )}`;
            window.open(fallbackUrl, "_blank", "noopener,noreferrer");
          }
        }
      } else {
        // Desktop or browsers without Web Share API -> open WhatsApp share cleanly
        const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          `${shareTitle} - ${shareText} ${shareUrl}`
        )}`;
        window.open(whatsappUrl, "_blank", "noopener,noreferrer");
      }
    } finally {
      setTimeout(() => {
        isSharingRef.current = false;
      }, 500);
    }
  };

  return (
    <>
      <HomeBanner />
      <LatestProperties />
      <ChooseProperties />
      {/* <RecentelySearched/> */}
      <BoostedProperty />
      {/* <BestCities /> */}
      {/* <OurAgents /> */}
      <RecommendedProperties />
      {/* <InsightsandTools /> */}
      {/* <PopularBuilders /> */}
      <OurClientSays />
      <Achivement />
      <ApartmentsVillas />
      <MoveInNow />
      <BHKchoiceInMind />
      {/* <CheckPropertyRates/> */}
      <ExploreOurServices />
      <ExploreRealEstate />

      {/* <CuratedPgCollections/> */}
      {/* <HomesByFurnishing/> */}
      {/* <Newslatter /> */}
      <div className="homewhatsapp desktopwhatsapp">
        <div className="homewhatsapp1">
          <div
            className="mgh-floating-share-btn"
            onClick={handleShare}
            role="button"
            tabIndex={0}
            title="Share EwRealty"
            aria-label="Share"
          >
            <FiShare2 className="mgh-share-btn-icon" />
          </div>
        </div>
      </div>
      <div className="homewhatsapp mobilewhatsapp">
        <div className="homewhatsapp1">
          <div
            className="mgh-floating-share-btn"
            onClick={handleShare}
            role="button"
            tabIndex={0}
            title="Share EwRealty"
            aria-label="Share"
          >
            <FiShare2 className="mgh-share-btn-icon" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
